import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Grid, TextField, Typography } from '@material-ui/core';
import { getProviderCredentialById, updateProviderCredentialById } from 'api/cms/provider';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import useSWR from 'swr';
import { toast } from 'react-toastify';

let schema = yup.object().shape({
  provider_credential: yup.string().test('is-json', 'Invalid JSON format', (value) => {
    try {
      JSON.parse(value);
      return true;
    } catch {
      return false;
    }
  }),
});

const ProviderCredential = ({ data = {} }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });
  const { data: provider, error } = useSWR(
    ['providerCredentialById', data.provider_id],
    (url, providerId) => getProviderCredentialById(providerId),
    { revalidateOnFocus: false, refreshInterval: 0, shouldRetryOnError: false },
  );

  const onSubmit = async (values) => {
    const payload = JSON.parse(values.provider_credential);
    // console.log('payload -> ', payload);
    try {
      const response = await updateProviderCredentialById(data.provider_id, {
        provider_credential: payload,
      });
      if (response.data.code === 0) {
        toast.success('updated');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.statusText);
    }
  };

  useEffect(() => {
    if (provider) {
      setValue('provider_credential', JSON.stringify(provider?.provider_credential));
    }
  }, [provider]);

  return (
    <Box>
      <Typography variant="h6" gutterBottom component="div">
        <div className="">Credential Settings</div>
      </Typography>
      <Grid container spacing={2} component="form" onSubmit={handleSubmit(onSubmit)}>
        <Grid item xs={12}>
          <Box display="flex" flexDirection="row">
            <Controller
              name="provider_credential"
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  multiline
                  maxRows={10}
                  minRows={5}
                  fullWidth
                  error={!!errors?.provider_credential}
                  helperText={errors?.provider_credential?.message}
                />
              )}
              control={control}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Button color="primary" variant="contained" type="submit">
            SAVE
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

ProviderCredential.propTypes = {
  data: PropTypes.object,
};

export default ProviderCredential;
